<template>
  <div
    class="ts-overview-card ts-overview-card--lg"
    :style="{
      backgroundImage:
        'url(' +
        $store.state.baseUrl +
        $store.state.overviewPage.ContentUsage.backgroundImage.data.attributes
          .url +
        ')',
    }"
  >
    <div class="ts-overview-card__content text-center mb-0 mt-auto">
      <h1 class="ts-fs-6-ii mb-0 fw-semibold text-white text-center">
        {{ $store.state.overviewPage.ContentUsage.title }}
      </h1>
      <p class="ts-fs-7-ii mb-0 text-white text-center">
        {{ $store.state.overviewPage.ContentUsage.description }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContentUsage",
};
</script>
